import moment from "moment";
import { enum_ADJUSTMENT_CALCULATION_TYPE,  } from "../../common/Dictionaries";
import { 
	SET_FIRST_LOAD,
	SET_FLY_POLINOMY_LIST,
	ADD_FLY_POLINOMY_LIST_ITEM,
	UPDATE_FLY_POLINOMY_LIST_ITEM,
	REMOVE_FLY_POLINOMY_LIST_ITEM,
	SET_FILTER_CONTRACT_LIST,
	SET_FILTER_CONTRACT_ITEM,
	DELETE_FILTER_CONTRACT_ITEM,
	SET_FILTER_INDEX_LIST,
	SET_FILTER_INDEX_ITEM,
	DELETE_FILTER_INDEX_ITEM,
	SET_SELECTED_FILTER_INDEX_LIST,
	SET_SELECTED_FILTER_PERIOD,
	SET_SELECTED_FILTER_CONTRACT_LIST,
	SET_CALCULATED_HEADER_IDS,
	ADD_CALCULATED_HEADER_ID,
	REMOVE_CALCULATED_HEADER_ID,
	SET_CALCULATED_POLINOMY_IDS,
	ADD_CALCULATED_POLINOMY_ID,
	REMOVE_CALCULATED_POLINOMY_ID,
	SET_CALCULATED_CALCULATOR_IDS,
	ADD_CALCULATED_CALCULATOR_ID,
	REMOVE_CALCULATED_CALCULATOR_ID,
	UPDATE_SELECTED_TYPE,
	SET_CONTRACTS,
	SET_POLINOMY_STRUCTURE_PARTIES,
	SET_POLINOMY_STRUCTURE_POLINOMY,
	SET_POLINOMY_STRUCTURE_POLINOMY_ITEM_CODIGOCONTRATO,
	SET_POLINOMY_STRUCTURE_CALCULATOR,
} from "../actions/Adjustment/actions";

const initialState = {
	//Se usará para indicar que lo inicial está cargado.
	_firsLoad: false,

	//Se usará para almacenar los elementos nuevos.
	_new_Fly_PolinomyList: [],

	//Se usarán de filtro en pantalla.
	_filter_Contract: null,
	_filter_Index: null,
	_filter_SelectedIndex: null,
	_filter_SelectedContracts: null,
	_filter_SelectedPeriod: `${moment(new Date()).format("DD/MM/YYYY")}`,

	//Se usarán para almacenar los elementos que están calculados en pantalla.
	_calculated_Header_Ids: [],
	_calculated_Polinomy_Ids: [],
	_calculated_Calculator_Ids: [],

	//Se usarán para almacenar los elementos expandidos y que despliegan el calculo realizado.
	_expanded_Calculation_Header_Ids: [],
	_expanded_Calculation_Polinomy_Ids: [],
	_expanded_Calculation_Calculator_Ids: [],

	//Se usará para alimentar selector de tipo de calculo.
	_calculationTypes: [
		{type: enum_ADJUSTMENT_CALCULATION_TYPE.ADJUSTMENT_FACTOR, selected: false},
		{type: enum_ADJUSTMENT_CALCULATION_TYPE.ADJUSTMENT_AMOUNT, selected: false}
	],

	//Se usará para alimentar el selector de contrato.
	_contracts: null,

	//Se usarán para alimentar la data main de la pantalla (Estructura de "elemento padre/polinomio de reajuste").
	_polinomy_Structure_Polinomy: null,
	_polinomy_Structure_Parties: null,
	_polinomy_Structure_Calculator: null,
};

const contractPartieReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_FIRST_LOAD:
			return {
				...state,
				_firsLoad: action.payload
			};

		case SET_FLY_POLINOMY_LIST:
			return {
				...state,
				_new_Fly_PolinomyList: action.payload
			};
		case ADD_FLY_POLINOMY_LIST_ITEM:
			return {
				...state,
				_new_Fly_PolinomyList: [...state._new_Fly_PolinomyList, action.payload],
			};
		case UPDATE_FLY_POLINOMY_LIST_ITEM:
			return {
				...state,
				_new_Fly_PolinomyList: state._new_Fly_PolinomyList.map(item => 
						item.id === action.payload.id ? action.payload : item
				)
			};
		case REMOVE_FLY_POLINOMY_LIST_ITEM:
			return {
				...state,
				_new_Fly_PolinomyList: state._new_Fly_PolinomyList.filter(item => item.id === action.payload.id)
			};
			



			
		case SET_SELECTED_FILTER_PERIOD:
			return {
				...state,
				_filter_SelectedPeriod: action.payload
			};

		case SET_SELECTED_FILTER_CONTRACT_LIST:
			return {
				...state,
				_filter_SelectedContracts: action.payload
			};
		case SET_FILTER_CONTRACT_LIST:
			return {
				...state,
				_filter_Contract: action.payload
			};
		case SET_FILTER_CONTRACT_ITEM:
			return {
				...state,
				_filter_Contract: [...state._filter_Contract, action.payload],

			};
		case DELETE_FILTER_CONTRACT_ITEM:
			return {
				...state,
				_filter_Contract: state._filter_Contract.filter(item => item.id === action.payload.id)
			};
			
		case SET_SELECTED_FILTER_INDEX_LIST:
			return {
				...state,
				_filter_SelectedIndex: action.payload
			};
		case SET_FILTER_INDEX_LIST:
			return {
				...state,
				_filter_Index: action.payload
			};
		case SET_FILTER_INDEX_ITEM:
			return {
				...state,
				_filter_Index: [...state._filter_Index, action.payload],
			};
		case DELETE_FILTER_INDEX_ITEM:
			return {
				...state,
				_filter_Index: state._filter_Index.filter(item => item.id === action.payload.id)
			};
			
			



		case SET_CALCULATED_HEADER_IDS:
			return {
				...state,
				_calculated_Header_Ids: action.payload
			};
		case ADD_CALCULATED_HEADER_ID:
			return {
				...state,
				_calculated_Header_Ids: [...state._calculated_Header_Ids, action.payload],
			};		
		case REMOVE_CALCULATED_HEADER_ID:
			return {
				...state,
				_calculated_Header_Ids: state._calculated_Header_Ids.filter(item => item.id === action.payload.id)
			};
	
		case SET_CALCULATED_POLINOMY_IDS:
			return {
				...state,
				_calculated_Polinomy_Ids: action.payload
			};
		case ADD_CALCULATED_POLINOMY_ID:
			return {
				...state,
				_calculated_Polinomy_Ids: [...state._calculated_Polinomy_Ids, action.payload],
			};		
		case REMOVE_CALCULATED_POLINOMY_ID:
			return {
				...state,
				_calculated_Polinomy_Ids: state._calculated_Polinomy_Ids.filter(item => item.id === action.payload.id)
			};	

		case SET_CALCULATED_CALCULATOR_IDS:
			return {
				...state,
				_expanded_Calculation_Calculator_Ids: action.payload
			};
		case ADD_CALCULATED_CALCULATOR_ID:
			return {
				...state,
				_expanded_Calculation_Calculator_Ids: [...state._expanded_Calculation_Calculator_Ids, action.payload],
			};		
		case REMOVE_CALCULATED_CALCULATOR_ID:
			return {
				...state,
				_expanded_Calculation_Calculator_Ids: state._expanded_Calculation_Calculator_Ids.filter(item => item.id === action.payload.id)
			};	
	
		case UPDATE_SELECTED_TYPE:
			return {
				...state,
				_calculationTypes: state._calculationTypes.map(item => 
				item.type === action.payload.type 
					? { ...item, selected: action.payload.selected } 
					: item
				),
			};
		
		case SET_CONTRACTS:
			return {
				...state,
				_contracts: action.payload
			};

		case SET_POLINOMY_STRUCTURE_PARTIES:
			return {
				...state,
				_polinomy_Structure_Parties: action.payload
			};		
		case SET_POLINOMY_STRUCTURE_POLINOMY:
			return {
				...state,
				_polinomy_Structure_Polinomy: action.payload
			};
		case SET_POLINOMY_STRUCTURE_POLINOMY_ITEM_CODIGOCONTRATO:
			return {
				...state,
				_polinomy_Structure_Polinomy: state._polinomy_Structure_Polinomy.map(item => 
						item.codigoContrato === action.payload.codigoContrato ? action.payload : item
				)
			};
		case SET_POLINOMY_STRUCTURE_CALCULATOR:
			return {
				...state,
				_polinomy_Structure_Calculator: action.payload
			};
		
		default:
			return state;
	}
};



export default contractPartieReducer;